//let data = "../images/"
let data = "https://www.vehicentro.com/co/images/"

let obj = {
    url:data
}

export default obj